import { Skeleton } from "@mui/material";
import classNames from "classnames";
import * as React from "react";

import { Expandable } from "../Expandable";

interface Props {
  /** Estimated number of files to render */
  estimatedFileCount: number;

  /** Optional class name to apply to the root element */
  className?: classNames.Argument;
}

const fileWidths = ["80%", "85%", "90%"];

export function FileSelectorSkeleton({ estimatedFileCount, className }: Props) {
  const widths = React.useMemo(() => {
    return Array.from({ length: estimatedFileCount }).map(() => {
      return fileWidths[Math.floor(Math.random() * fileWidths.length)];
    });
  }, [estimatedFileCount]);

  return (
    <div className={classNames(className)}>
      {Array.from({ length: estimatedFileCount }).map((_, i) => (
        <Expandable<undefined> key={i} data={undefined}>
          <div style={{ width: widths[i] }}>
            <Skeleton animation="wave" variant="text" />
          </div>
        </Expandable>
      ))}
    </div>
  );
}
